export default {
  title: 'Informazioni di pagamento verificate',
  description: 'Le tue informazioni di pagamento sono state verificate con successo.',
};
